

<style scoped  lang="less" >
.content {
  margin: 0 auto;
  background: #fff;
  width: 1200px;
  padding: 0px 16px;
}
.relative_z1 {
  position: relative;
  z-index: 1;
}
.DetailsHead {
  position: sticky;
  top: 0;
  z-index: 98;
}
.pop-setting-show {
  z-index: 1000 !important;
}
.DetailsTab {
  z-index: 99;
  top: 162px;
  position: sticky;
}
.DetailsTab_on {
  top: 80px;
}
.MatchSummary {
  .relative_z1();
}
.MatchStats {
  .relative_z1();
}
.MatchLine {
  .relative_z1();
}
.MatchEvent {
  .relative_z1();
}
.Odds {
  .relative_z1();
}
.H2H {
  .relative_z1();
}
.Standings {
  .relative_z1();
}
@media screen and (max-width: 767px) {
  .content {
    padding: 0rem !important;
    width: 100%;
  }
  .DetailsTab {
    top: 1.42rem;
  }
  .DetailsTab_on {
    top: 0.44rem;
  }
  #indexComponent {
    width: 100%;
    overflow: hidden;
  }
  // .DetailsHead{position: sticky;top:0;z-index: 98;}
}
</style>
<template>
  <div id="indexComponent">
    <Header
      ref="Header"
      @onChangeSetting="onChangeHeader"
      :setShow="['oddsForm']"
      :minWidth="true"
    />
    <!-- 内容 -->
    <div class="content">
      <!-- 面包屑 -->
      <DetailsCrumbs ref="DetailsCrumbs" :league="league" />
      <!-- <a href="javascript:void(0);" @click="socketData">开启</a>  -->
      <!-- 头部 -->
      <DetailsHead
        ref="DetailsHead"
        :match="match"
        :isHeadDown="isHeadDown.isShow"
        :isFollow="isFollow"
        class="DetailsHead"
      />
      <!-- <a href="javascript:void(0);" @click="kaiqi">调试按钮，测试别报BUG</a>
      <div class="aaaa">
        <a href="javascript:void(0);" @click="aaa">指数Odds更新试推-别报BUG</a> 
      </div> -->

      <!-- <a href="javascript:void(0);" @click="kaiqi">调试按钮，测试别报BUG</a>
      <a href="javascript:void(0);" @click="aaa">调试按钮2，测试别报BUG</a> -->
      <!-- <a href="javascript:void(0);" @click="kaiqi">调试按钮，测试别报BUG</a> 
      <router-link :to="{path:'/details/4446474?tab=StATs'}">
        StATs
        </router-link>
      <router-link :to="{path:'/details/4446474?tab=ODDS'}">
        ODDS11
        </router-link> -->
      <!-- tab -->
      <DetailsTab
        class="DetailsTab"
        :class="isHeadDown.isShow ? 'DetailsTab_on' : ''"
        ref="Tab"
        @onTabChange="onTabChange"
        :newTabData="newTabData"
        :isHeadDown="isHeadDown.isShow"
        :match="match"
      />
      <!-- Match-Summary -->
      <MatchSummary
        class="MatchSummary"
        v-if="tabData.tabId == 1 && tabData.childID == 1"
        :matchId="matchId"
        :match="match"
        :socketKeyList="socketKeyList"
        :isRead="tabSave['1-1'].isRead"
      />
      <MatchStats
        class="MatchStats"
        v-if="tabData.tabId == 1 && tabData.childID == 2"
        :matchId="matchId"
        :socketStatsList="socketStatsList"
        :isRead="tabSave['1-2'].isRead"
      />
      <MatchLine
        class="MatchLine"
        v-if="tabData.tabId == 1 && tabData.childID == 3"
        :matchId="matchId"
        :isRead="tabSave['1-3'].isRead"
      />
      <MatchEvent
        class="MatchEvent"
        v-if="tabData.tabId == 1 && tabData.childID == 4"
        :matchId="matchId"
        :match="match"
        :socketEventList="socketEventList"
        :isRead="tabSave['1-4'].isRead"
      />
      <Odds
        class="Odds"
        v-if="tabData.tabId == 2"
        :matchId="matchId"
        :match="match"
        :OddsRadio="OddsRadio"
        :socketLuckList="socketLuckList"
        :isRead="tabSave['2-0'].isRead"
      />
      <H2H
        class="H2H"
        v-if="tabData.tabId == 3"
        :matchId="matchId"
        :league="league"
        :match="match"
      />
      <Standings
        class="Standings"
        v-if="tabData.tabId == 4"
        :matchId="matchId"
        :league="league"
        :match="match"
        :socketStandingsList="socketStandingsList"
        :isRead="tabSave['4-0'].isRead"
      />
      <Prediction
        class="Prediction"
        v-if="tabData.tabId == 5"
        :matchId="matchId"
        :league="league"
        :match="match"
      />
    </div>
    <Footer :minWidth="true" />
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import DaseDatetime from "@/components/baseDatetime.vue";
import DetailsCrumbs from "@/views/details/components/detailsCrumbs.vue"; //顶部面包屑
import DetailsHead from "@/views/details/components/detailsHead.vue"; //头部
import DetailsTab from "@/views/details/components/detailsTab.vue"; //tab
import MatchSummary from "@/views/details/components/detailsMatchSummary.vue"; //tab-Match-Summary
import MatchStats from "@/views/details/components/detailsMatchStats.vue"; //tab-Match-Stats
import MatchLine from "@/views/details/components/detailsMatchLine.vue"; //tab-Match-Line
import MatchEvent from "@/views/details/components/detailsMatchEvent.vue"; //tab-Match-MatchEvent
import Odds from "@/views/details/components/detailsOdds.vue";
import Standings from "@/views/details/components/detailsStandings.vue";
import H2H from "@/views/details/components/detailsH2H.vue";
import Prediction from "@/views/details/components/detailsPrediction.vue";

import {
  getMatchInfo,
  getSocket,
  getSocketUpdate,
  getMatchInfoIsFollow,
  getSEO,
} from "@/api/api";
export default {
  name: "index",
  components: {
    Header,
    Footer,
    DaseDatetime,
    DetailsCrumbs,
    DetailsHead,
    DetailsTab,
    MatchSummary,
    MatchStats,
    MatchLine,
    MatchEvent,
    Odds,
    Standings,
    H2H,
    Prediction,
  },

  props: {},
  // asyncData ( { store, route } ) {
  //     console.log('route1111',route);
  //     return  store.dispatch('details/fetchSEO', {
  //         type: 2
  //     })
  // },

  data() {
    return {
      tabData: {
        //
        tabId: 1,
        childID: 1,
      },

      baseParam: {
        userToken: "",
        platform: 4, //平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
      },
      newTabData: null,
      //data
      league: null, //赛事
      match: null, //比赛基础信息
      isHeadDown: false, //头部伸缩
      matchId: null, //4495439  英超   4618543 4495457
      socketKeyList: [], //socket更新：关键事件-概况
      socketStatsList: [], //socket更新：事件统计
      socketEventList: [], //socket更新：事件直播
      socketStandingsList: {}, //socket更新：积分版
      socketLuckList: {}, //ocket ODDS更新：积分版
      isHeadDown: {
        isShow: false, //头部伸缩
        DetailsHead_show: 0,
        DetailsHead_hide: 0,
      },
      OddsRadio: 0,
      state: -1, //比赛状态
      isFollow: null,
      isDownShow: false,
      format: 222,
      matchId2: null,
      tabSave: {
        "1-1": {
          name: "Summary",
          oneShow: false,
          tabShow: true,
          isData: true,
          isRead: 0,
        },
        "1-2": {
          name: "Stats",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "1-3": {
          name: "LineUps",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "1-4": {
          name: "Event",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "2-0": {
          name: "Odds",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "3-0": {
          name: "H2H",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "4-0": {
          name: "Standings",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
        "5-0": {
          name: "Prediction",
          oneShow: false,
          tabShow: false,
          isData: false,
          isRead: 0,
        },
      },
    };
  },

  computed: {
    ...mapState("details", ["SEO"]),
  },

  methods: {
    //头部切换的回调
    onChangeHeader(e) {
      //console.log('eeeee',e);
      this.OddsRadio = new Date().getTime();
      this.handleScroll();
      // if(_oddsForm != _setting.oddsFormRadio*1){ //赔率格式
      //   this.oddsForm = _setting.oddsFormRadio*1;
      //   this.liveDatas.oddsForm = _setting.oddsFormRadio*1;
      // }
    },
    //获取比赛更新
    async getSocketRenewal(isRefresh) {
      //比赛信息+概况
      var _this = this;
      let tabSave = JSON.parse(JSON.stringify(this.tabSave));
      let tabData = JSON.parse(JSON.stringify(this.tabData));
      let match = JSON.parse(JSON.stringify(this.match));
      let matchId = JSON.parse(JSON.stringify(this.matchId));

      if (!match || !([1, 2, 3, 8, 11, 13, 17].indexOf(match.state * 1) > -1)) {
        return;
      }
      //console.log('SocketRenewal优化555',!match,match.state,!([1,2,3,8,11,13,17].indexOf(match.state*1)>-1))
      let param = {
        type: 111,
        matchId: matchId,
      };

      // await this.$socket.registerCallBack('FootballMatchDetailUpdate_111', async()=>{
      //   await getSocket(this,param);
      //   await _this.common.debounce(_this.this.getMatchInfoData(),10)
      // });

      console.log("getSocketUpdate", "打开", tabSave, isRefresh);
      console.log(
        "1-1",
        (tabSave["1-1"].isData &&
          !tabSave["1-1"].oneShow &&
          tabSave["1-1"].tabShow &&
          (!isRefresh || isRefresh == "1-1")) ||
          (isRefresh == "-1" && tabSave["1-1"].oneShow)
      );
      console.log(
        "1-2",
        (tabSave["1-2"].isData &&
          !tabSave["1-2"].oneShow &&
          tabSave["1-2"].tabShow &&
          (!isRefresh || isRefresh == "1-2")) ||
          (isRefresh == "-1" && tabSave["1-2"].oneShow)
      );
      console.log(
        "1-4",
        (tabSave["1-4"].isData &&
          !tabSave["1-4"].oneShow &&
          tabSave["1-4"].tabShow &&
          (!isRefresh || isRefresh == "1-4")) ||
          (isRefresh == "-1" && tabSave["1-4"].oneShow)
      );
      console.log(
        "4-0",
        (tabSave["4-0"].isData &&
          !tabSave["4-0"].oneShow &&
          tabSave["4-0"].tabShow &&
          (!isRefresh || isRefresh == "4-0")) ||
          (isRefresh == "-1" && tabSave["4-0"].oneShow)
      );
      console.log(
        "2-0",
        (tabSave["2-0"].isData &&
          !tabSave["2-0"].oneShow &&
          tabSave["2-0"].tabShow &&
          (!isRefresh || isRefresh == "2-0")) ||
          (isRefresh == "-1" && tabSave["2-0"].oneShow)
      );

      if (
        (tabSave["1-1"].isData &&
          !tabSave["1-1"].oneShow &&
          tabSave["1-1"].tabShow &&
          (!isRefresh || isRefresh == "1-1")) ||
        (isRefresh == "-1" && tabSave["1-1"].oneShow)
      ) {
        tabSave["1-1"].oneShow = true;
        await getSocket(this, param); // 开启socket比分更新请求
        console.log("Socket-基础信息开启");
        await this.$socket.registerCallBack(
          "FootballMatchDetailUpdate",
          function (res) {
            var resData = getSocketUpdate(res, "FootballMatchDetailUpdate");
            resData = JSON.parse(JSON.stringify(resData));
            //console.log('SocketUpdate_基础'+param.matchId,resData);
            console.log(
              "SocketUpdate_基础-字符串" + param.matchId,
              JSON.stringify(resData)
            );
            //console.log('SocketUpdate_基础2'+param.matchId,resData.updateMatch);
            _this.socketData(1, resData);
          }
        );
        await this.$socket.registerCallBack(
          "FootballMatchDetailGoalUpdate",
          function (res) {
            var resData = getSocketUpdate(res, "FootballMatchDetailGoalUpdate");
            resData = JSON.parse(JSON.stringify(resData));
            //console.log('SocketUpdate_事件'+param.matchId,resData);
            console.log(
              "SocketUpdate_事件-字符串" + param.matchId,
              JSON.stringify(resData)
            );
            if (resData && resData.keyList) {
              _this.socketData(2, resData);
            }
          }
        );
        await this.$socket.registerCallBack(
          "FootballMatchDetailLuckUpdate",
          function (res) {
            var resData = getSocketUpdate(res, "FootballMatchDetailLuckUpdate");
            resData = JSON.parse(JSON.stringify(resData));
            //console.log('SocketUpdate_指数'+param.matchId,resData);
            //console.log('SocketUpdate_指数-字符串'+param.matchId, JSON.stringify(resData));
            _this.socketData(3, resData);
          }
        );
      }

      if (
        (tabSave["1-2"].isData &&
          !tabSave["1-2"].oneShow &&
          tabSave["1-2"].tabShow &&
          (!isRefresh || isRefresh == "1-2")) ||
        (isRefresh == "-1" && tabSave["1-2"].oneShow)
      ) {
        tabSave["1-2"].oneShow = true;
        //事件统计
        let param_115 = {
          type: 115,
          matchId: matchId,
        };
        console.log("Socket-事件统计开启");
        await getSocket(this, param_115); // 开启socket-事件统计-更新请求
        // await this.$socket.registerCallBack('FootballMatchStatsUpdate_115', ()=>getSocket(this,param_115));
        await this.$socket.registerCallBack(
          "FootballMatchStatsUpdate",
          function (res) {
            var resData = JSON.parse(
              JSON.stringify(getSocketUpdate(res, "FootballMatchStatsUpdate"))
            );
            //console.log('SocketUpdate_事件统计'+param.matchId,resData);
            console.log(
              "SocketUpdate_事件统计-字符串" + param.matchId,
              JSON.stringify(resData)
            );
            if (matchId == resData.matchId) {
              _this.socketStatsList = resData.updateData.stats || [];
            }
          }
        );
      }
      if (
        (tabSave["1-4"].isData &&
          !tabSave["1-4"].oneShow &&
          tabSave["1-4"].tabShow &&
          (!isRefresh || isRefresh == "1-4")) ||
        (isRefresh == "-1" && tabSave["1-4"].oneShow)
      ) {
        tabSave["1-4"].oneShow = true;
        //事件直播更新
        let param_112 = {
          type: 112,
          matchId: matchId,
        };
        console.log("Socket-事件直播开启");
        await getSocket(this, param_112); // 开启socket-事件直播更新-更新请求
        //await this.$socket.registerCallBack('FootballMatchEventUpdate_112', ()=>getSocket(this,param_112));
        await this.$socket.registerCallBack(
          "FootballMatchEventUpdate",
          function (res) {
            var resData = JSON.parse(
              JSON.stringify(getSocketUpdate(res, "FootballMatchEventUpdate"))
            );
            //console.log('SocketUpdate_事件直播'+param.matchId,resData);
            console.log(
              "SocketUpdate_事件直播-字符串" + param.matchId,
              JSON.stringify(resData)
            );
            if (matchId == resData.matchId) {
              _this.socketEventList = resData.updateData["eventList"] || [];
            }
          }
        );
      }
      if (
        (tabSave["4-0"].isData &&
          !tabSave["4-0"].oneShow &&
          tabSave["4-0"].tabShow &&
          (!isRefresh || isRefresh == "4-0")) ||
        (isRefresh == "-1" && tabSave["4-0"].oneShow)
      ) {
        tabSave["4-0"].oneShow = true;
        //积分版更新
        let param_113 = {
          type: 113,
          matchId: matchId,
        };
        console.log("Socket-积分版开启");
        await getSocket(this, param_113); // 开启socket-事件直播更新-更新请求
        // await this.$socket.registerCallBack('FootballMatchStandingUpdate_113', ()=>getSocket(this,param_113));
        await this.$socket.registerCallBack(
          "FootballMatchStandingUpdate",
          function (res) {
            var resData = JSON.parse(
              JSON.stringify(
                getSocketUpdate(res, "FootballMatchStandingUpdate")
              )
            );
            //console.log('SocketUpdate_积分版统计'+param.matchId,resData);
            console.log(
              "SocketUpdate_积分版统计-字符串" + param.matchId,
              JSON.stringify(resData)
            );
            if (matchId == resData.matchId) {
              _this.socketStandingsList = resData.updateData || [];
            }
          }
        );
      }
      if (
        (tabSave["2-0"].isData &&
          !tabSave["2-0"].oneShow &&
          tabSave["2-0"].tabShow &&
          (!isRefresh || isRefresh == "2-0")) ||
        (isRefresh == "-1" && tabSave["2-0"].oneShow)
      ) {
        tabSave["2-0"].oneShow = true;
        //odds
        let param_114 = {
          type: 114,
          matchId: matchId,
        };
        await getSocket(this, param_114); // 开启socket-odds-更新请求

        console.log("Socket-ODDS开启");
        //  await this.$socket.registerCallBack('FootballMatchLuckUpdate_114', ()=>getSocket(this,param_114));
        await this.$socket.registerCallBack(
          "FootballMatchLuckUpdate",
          function (res) {
            var resData = JSON.parse(
              JSON.stringify(getSocketUpdate(res, "FootballMatchLuckUpdate"))
            );
            //console.log('SocketUpdate_指数odds统计'+param.matchId,resData);
            console.log(
              "SocketUpdate_指数odds统计-字符串" + param.matchId,
              JSON.stringify(resData)
            );

            if (matchId == resData.matchId) {
              let socketLuckList = {
                asian: resData.asian || [],
                threeWay: resData.threeWay || [],
                total: resData.total || [],
              };
              _this.socketLuckList = socketLuckList;
            }
          }
        );
      }

      await this.$socket.registerCallBack("FootballListReconnect", async () => {
        _this.getMatchInfoData();
        // await getSocket(this,param);
        // if(tabSave['1-4'].isData && tabSave['1-4'].oneShow && tabSave['1-4'].tabShow){
        //   await getSocket(this,param_112);
        // }
        // if(tabSave['4-0'].isData && tabSave['4-0'].oneShow && tabSave['4-0'].tabShow){
        //   await getSocket(this,param_113);
        // }
        // if(tabSave['2-0'].isData && tabSave['2-0'].oneShow && tabSave['2-0'].tabShow){
        //   await getSocket(this,param_114);
        // }
        // if(tabSave['1-2'].isData && tabSave['1-2'].oneShow && tabSave['1-2'].tabShow){
        //   await getSocket(this,param_115);
        // }
        tabSave[tabData.tabId + "" + "-" + "" + tabData.childID].isRead =
          new Date().getTime();
        console.log(
          "socket重连" + tabData.tabId + "" + "-" + "" + tabData.childID
        );
        _this.getSocketRenewal("-1");
        //await _this.common.debounce(_this.getMatchInfoData(),500);
      });

      //console.log('SocketRenewal优化6666');
      this.tabSave = tabSave;
    },
    //比赛基础信息 socket数据更新
    socketData(type, data) {
      const _this = this;
      let match = JSON.parse(JSON.stringify(this.match)) || {};
      let matchId = JSON.parse(JSON.stringify(this.matchId));
      let state = JSON.parse(JSON.stringify(this.state));
      //console.log('match',match);
      //console.log('matchId',matchId);
      //console.log('socketD323a',data.updateMatch);
      //console.log('match',JSON.stringify(this.match));

      if (type == 1 && data.matchId * 1 == matchId * 1) {
        //基础数据
        let _match = this.common.mergeObjects(match, data.updateMatch);
        this.match = _match;
        if (state != -1 && state != _match.state) {
          _this.getMatchInfoData();
        }
      } else if (type == 2 && data.matchId * 1 == matchId * 1) {
        //事件
        //console.log('socketData2',data);
        this.socketKeyList = data.keyList;
      } else if (type == 3 && data.matchId * 1 == matchId * 1) {
        //指数
        //console.log('socketData3',data);
        // asian:{companyId: '3000181', hand: '-0.5', home: '0.82', away: '0.97'}
        // matchId: "4634718"
      }
    },
    kaiqi() {
      this.getMatchInfoData();
      this.tabUrlInit();
    },
    aaa() {
      var _this = this;
      let matchId = JSON.parse(JSON.stringify(this.matchId));
      var resData = {
        matchId: "4568522",
        asian: [
          { companyId: "3000248", hand: "0", home: "0.85", away: "0.9" },
          { companyId: "4000000", hand: "0", home: "0.83", away: "1.05" },
          { companyId: "3000181", hand: "0", home: "0.85", away: "1" },
          { companyId: "3000390", hand: "0", home: "0.86", away: "1.06" },
          { companyId: "3000048", hand: "0", home: "0.91", away: "0.9" },
          { companyId: "3000379", hand: "0", home: "0.91", away: "0.99" },
          { companyId: "3000343", hand: "0", home: "0.88", away: "1.02" },
          { companyId: "3000471", hand: "0", home: "0.91", away: "0.99" },
          { companyId: "3000368", hand: "0", home: "0.86", away: "1.04" },
          { companyId: "3001000", hand: "0", home: "0.9", away: "0.98" },
        ],
        threeWay: [
          { companyId: "4000000", home: "2.91", draw: "2.42", away: "3.1" },
          { companyId: "3000068", home: "2.87", draw: "2.5", away: "3" },
          { companyId: "3000181", home: "3", draw: "2.4", away: "3.2" },
          { companyId: "3000021", home: "2.9", draw: "2.4", away: "2.8" },
          { companyId: "3000390", home: "2.9", draw: "2.42", away: "3.1" },
          { companyId: "3000048", home: "2.9", draw: "2.6", away: "2.9" },
          { companyId: "3000379", home: "2.88", draw: "2.37", away: "3" },
          { companyId: "3000004", home: "2.95", draw: "2.5", away: "3" },
          { companyId: "3000271", home: "3.13", draw: "2.46", away: "3" },
          { companyId: "3000343", home: "2.91", draw: "2.42", away: "3.1" },
          { companyId: "3000471", home: "2.88", draw: "2.37", away: "3" },
          { companyId: "3000368", home: "2.79", draw: "2.41", away: "3.03" },
          { companyId: "3001000", home: "2.57", draw: "2.48", away: "3.22" },
        ],
        total: [
          { companyId: "4000000", total: "1.5", over: "1.07", under: "0.79" },
          { companyId: "3000068", total: "2.5", over: "2.9", under: "0.22" },
          { companyId: "3000181", total: "1.5", over: "1.02", under: "0.82" },
          { companyId: "3000390", total: "1.5", over: "1.07", under: "0.83" },
          { companyId: "3000048", total: "1.5", over: "0.95", under: "0.88" },
          { companyId: "3000379", total: "1.5", over: "1.05", under: "0.83" },
          { companyId: "3000004", total: "1.5", over: "0.9", under: "0.8" },
          { companyId: "3000343", total: "1.5", over: "1.06", under: "0.82" },
          { companyId: "3000471", total: "1.5", over: "1.03", under: "0.85" },
          { companyId: "3000368", total: "1.5", over: "1.07", under: "0.81" },
        ],
      };
      resData.matchId = this.$route.params.id * 1;
      if (matchId == resData.matchId) {
        let socketLuckList = {
          asian: resData.asian || [],
          threeWay: resData.threeWay || [],
          total: resData.total || [],
        };
        _this.socketLuckList = socketLuckList;
      }
    },
    aaa2() {
      this.getMatchInfoData();
    },
    //获取滚动条高度
    handleScroll() {
      var _this = this;

      if (typeof window != "undefined") {
        var isWeb = window.innerWidth < 767 ? true : false;
        const DetailsTab_ref = _this.$refs.Tab;
        //console.log('ref_gameHead',ref_gameHead);

        // if(DetailsTab_ref){
        //   const topOffsettab = DetailsTab_ref.$el.getBoundingClientRect();
        //   //console.log('DetailsTab_ref',topOffsettab,topOffsettab.top,topOffsettab.offsetTop,window.innerHeight);
        // }
        // var DetailsTab_top=topOffsettab.top;
        var viewportHeight = window.innerHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        let Header = this.$refs.Header
          ? this.$refs.Header.$el.clientHeight * 1
          : null;
        let DetailsCrumbs = this.$refs.DetailsCrumbs
          ? this.$refs.DetailsCrumbs.$el.clientHeight * 1
          : null;
        let DetailsHead = this.$refs.DetailsHead
          ? this.$refs.DetailsHead.$el.clientHeight * 1
          : null;
        let topOffset = this.$refs.DetailsHead
          ? this.$refs.DetailsHead.$el.getBoundingClientRect()
          : null;
        let pageHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight; //屏幕高度
        // let pageHeight && topOffset.bottom <= window.innerHeight
        if (!Header || !DetailsCrumbs || !DetailsHead) {
          return;
        }
        var isLong =
          pageHeight - Header - DetailsCrumbs - DetailsHead * 0.6 >
          window.innerHeight;
        //var isLong=(pageHeight-Header-DetailsCrumbs)>window.innerHeight;
        let isHeadDown = JSON.parse(JSON.stringify(this.isHeadDown));
        var dif_H = scrollTop - Header * (isWeb ? 2.3 : 2) - DetailsCrumbs;
        // if(!isShow){//未收缩
        //   var dif_H= scrollTop-Header-DetailsCrumbs;
        // }else{
        //   var dif_H= scrollTop-Header-DetailsCrumbs+DetailsHead;
        // }
        // isHeadDown.isShow=isShow;
        // if(!isShow){//未收缩
        //   isHeadDown.DetailsHead_show=DetailsHead;
        // }else{ 1
        //   isHeadDown.DetailsHead_hide=DetailsHead;
        //   if(isHeadDown.DetailsHead_show!==0&&isHeadDown.DetailsHead!==0){
        //     var difHead=isHeadDown.DetailsHead_show-isHeadDown.DetailsHead_hide;
        //     dif_H= scrollTop-Header-DetailsCrumbs-difHead;
        //   }
        // }
        // var DetailsHead_show=JSON.parse(JSON.stringify(isHeadDown.DetailsHead_show));
        // var DetailsHead_hide=JSON.parse(JSON.stringify(isHeadDown.DetailsHead_hide));
        // if(!DetailsHead_hide&&DetailsHead_show){
        //   DetailsHead_hide=DetailsHead_show*0.3;
        // }else{
        //   DetailsHead_hide=DetailsHead;
        // }
        // if(!DetailsHead_show&&DetailsHead_hide){
        //   DetailsHead_show=DetailsHead_hide*3.44;
        // }else{
        //   DetailsHead_show=DetailsHead;
        // }

        ////console.log('dif_H',dif_H);
        ////console.log('topOffset',isLong,window.innerHeight,pageHeight,topOffset);
        //console.log('topOffset2',window.innerHeight,topOffset.bottom,topOffset.bottom <= window.innerHeight);

        let isShow = (dif_H > 0 ? true : false) && isLong;

        // if(isShow!=isHeadDown.isShow){
        //    if(isShow){
        // //     ////console.log('Header*1+1*DetailsCrumbs',Header*1+1*DetailsCrumbs);

        //       setTimeout(function() {
        //         window.scrollTo({
        //           top: Header*1+1*DetailsCrumbs+2*1,
        //           // behavior: 'smooth', // 添加这个可以实现平滑滚动
        //         });
        //       }, 10);
        //   }
        // // }

        isHeadDown.isShow = isShow;
        // DetailsHead
        this.isHeadDown = isHeadDown;
      }
    },
    //TAB回调
    onTabChange(e) {
      //console.log('onTabChange',e);
      var _this = this;
      let tabSave = JSON.parse(JSON.stringify(this.tabSave));
      this.tabData = e;
      console.log(
        "SocketRenewal优化222",
        e.tabId + "-" + "" + e.childID,
        tabSave[e.tabId + "-" + "" + e.childID].oneShow
      );
      if (!tabSave[e.tabId + "-" + "" + e.childID].oneShow) {
        //console.log('SocketRenewal优化3333')
        // tabSave[e.tabId+'-'+''+e.childID].oneShow=true;
        tabSave[e.tabId + "-" + "" + e.childID].tabShow = true;
        console.log("tabSave111", tabSave);
        this.tabSave = tabSave;
        setTimeout(function () {
          _this.common.debounce(
            _this.getSocketRenewal(e.tabId + "-" + "" + e.childID),
            500
          );
        }, 10);
      }
      //  tabId  childID
      // const currentParams = this.$route.params;
      // const currentQuery = this.$route.query;

      // 修改 tab 参数的值为 'ODDS'
      // const updatedQuery = { ...currentQuery, tab: e.name };
      //console.log('currentParams',currentParams);
      //console.log('currentQuery',currentQuery);
      //console.log('updatedQuery',updatedQuery);
      ////console.log('e.name',e.name);
      // 使用 $router.push 更新 URL
      // this.$router.push({ name: 'details', params: currentParams, query: updatedQuery });
    },
    //基础信息读取
    async getMatchInfoData() {
      var _userInfo = "";
      let tabSave = JSON.parse(JSON.stringify(this.tabSave));
      if (typeof window != "undefined") {
        _userInfo = this.common.getCookie("userInfo") || "{}"; //
        _userInfo = JSON.parse(_userInfo);
        //console.log('_userInfo',_userInfo,_userInfo.token||'');
      }
      let obj = {
        matchId: this.matchId,
        userToken: _userInfo.token || "",
      };
      //console.log('obj',obj);
      var _this = this;
      let param = Object.assign(this.baseParam, obj);
      //console.log('param',param);
      var state = JSON.parse(JSON.stringify(this.state)) * 1;

      //_userInfo.token
      //console.log('par11111am',param);
      await getMatchInfo(param)
        .then((res) => {
          let data = JSON.parse(JSON.stringify(res.data));
          let res1 = JSON.parse(JSON.stringify(res));
          // let data=res.data;
          _this.league = data.league; //联赛赋值
          data.match.serverTimestamp = data.serverTimestamp; //系统时间
          data.match.hasStanding = data.league.hasStanding || false; //积分版

          // data.match.state=17;
          // data.match.startTime=1705064992;  //1704996000  1705062992
          //console.log('getMatchInfo——res1',res)
          //console.log("getMatchInfo——data", data);
          //console.log('isFollow',data.isFollow,data.isFollow||false)

          //TAB判断
          let hasLineup = data.match.hasLineup || false; //是否有阵容 0非1=正式2=预测
          let hasStats = data.match.hasStats || false; //是否有统计 0非1是
          let hasEventLive = data.match.hasEventLive || false; //是否有事件直播 0非1是
          let hasLuck = data.match.hasLuck || false; //是否有指数
          let hasPrediction = data.match.hasPrediction || false; //是否有情报
          let hasStanding = data.match.hasStanding || false; //积分版
          //console.log('阵容',hasLineup,'Stats统计',hasStats,'直播',hasEventLive,'指数',hasLuck,'积分',hasStanding,'情报',hasPrediction);
          tabSave["1-2"].isData = hasStats; //统计
          tabSave["1-3"].isData = hasLineup; //阵容
          tabSave["1-4"].isData = hasEventLive; //事件直播
          tabSave["2-0"].isData = hasLuck; //事件直播
          tabSave["4-0"].isData = hasStanding; //积分版
          tabSave["5-0"].isData = hasPrediction; //积分版
          this.tabSave = tabSave;

          //_this.isFollow =data.isFollow||false;
          _this.match = data.match;
          _this.state = data.match.state;
          //比赛状态：1上半场 2中场休息 3下半场 4完场 5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 17未开赛
          if (
            state == -1 &&
            [1, 2, 3, 8, 11, 13, 17].indexOf(data.match.state * 1) > -1
          ) {
            _this.getSocketRenewal(false);
          }
        })
        .catch((res) => {
          console.error(res);
        });

      await getMatchInfoIsFollow(param)
        .then((res) => {
          if (res.state == 200) {
            let data = JSON.parse(JSON.stringify(res.data));
            _this.isFollow = data.isFollow || false;
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
    //tab初始化显示模块
    tabUrlInit() {
      // var tab=this.$route.query.tab;
      // var title=this.$route.params.title;
      // var tab=(this.$route.params.tab!=undefined?this.$route.params.tab:'');
      // var id=this.$route.params.id;
      //var tab=this.$route.query.tab;
      // var tab=this.$route.query.tab;
      var tab = "";
      if (this.$route.params.tab != undefined) {
        tab = this.$route.params.tab;
        //console.log('这里tab',tab);
      }
      //console.log('ta11btabta22b',this.$route.params,this.$route.params.aaa);
      var tabObj = {
        summary: { tabId: 1, childID: 1 },
        stats: { tabId: 1, childID: 2 },
        lineups: { tabId: 1, childID: 3 },
        event: { tabId: 1, childID: 4 },
        odds: { tabId: 2, childID: 0 },
        h2h: { tabId: 3, childID: 0 },
        standings: { tabId: 4, childID: 0 },
        prediction: { tabId: 5, childID: 0 },
      };
      if (tab) {
        //tab
        // if(tab.toLowerCase()=='live'){
        //   tab=summary;
        // }
        ////console.log(1122,tabObj[tab.toLowerCase()],tabObj[tab.toLowerCase()]!=undefined);//.toLowerCase()

        if (tabObj[tab.toLowerCase()] != undefined) {
          //console.log(11111,tabObj[tab.toLowerCase()]);
          // this.tabData={tabId: 2, childID: 1};

          // this.newTabData=[{tabId: 2, childID: 1}];
          //  return;
          this.tabData = tabObj[tab.toLowerCase()];
          this.newTabData = tabObj[tab.toLowerCase()];
        }
        // if(tabObj[tab.toLowerCase()]){
        //   this.tabData=tabObj[tab];
        //   this.newTabData=tabObj[tab];
        //   //this.$refs?.Tab?.setTabData(tabObj[tab].tabId,tabObj[tab].childID);
        // }
      }
    },
    //初始化
    init() {
      //this.tabData=this.$refs.Tab.getTabData();
      this.tabUrlInit();
      this.getMatchInfoData();
      this.checkgameHeadView();
    },

    checkgameHeadView() {
      return;
      var _this = this;
      if (typeof window != "undefined") {
        //console.log('checkgameHeadView',111);
        var gameHead = _this.$refs.DetailsHead;
        //console.log('gameHead',gameHead);
        if (gameHead) {
          var rect = gameHead.getBoundingClientRect();
          //console.log('rect.top',rect.top,rect);
          _this.isHeadDown = rect.top >= 1 && rect.bottom <= window.innerHeight;
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      // 在URL变化时执行的代码
      //console.log('URL变化了');
      this.tabUrlInit();
      //console.log('新的路由:', to);
      //console.log('旧的路由:', from);
    },
  },
  created() {
    getSEO({
      //SEO
      type: 2,
    })
      .then((res) => {
        let _data = JSON.parse(JSON.stringify(res.data));
        document.title = _data.title;
        document.getElementsByName("keywords")[0].content = _data.keyword;
        document.getElementsByName("description")[0].content =
          _data.description;
      })
      .catch((res) => {
        console.error(res);
      });

    //初始化
    this.matchId = this.$route.params.id * 1;
    this.init();
  },
  mounted() {
    // this.tabData=this.$refs.Tab.getTabData();
    // this.$refs.Tab.setTabData(1,1);
    // 监听body滚动事件  debounce
    var _this = this;
    if (typeof window != "undefined") {
      window.addEventListener(
        "scroll",
        _this.common.debounce(_this.handleScroll, 20)
      );
    }
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    if (typeof window != "undefined") {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },

  destroyed() {
    // 在组件销毁前关闭WebSocket连接
    this.$socket.unRegisterCallBack("FootballMatchDetailUpdate");
    this.$socket.unRegisterCallBack("FootballMatchDetailGoalUpdate");
    this.$socket.unRegisterCallBack("FootballMatchDetailLuckUpdate");
    this.$socket.unRegisterCallBack("FootballMatchStatsUpdate");
    this.$socket.unRegisterCallBack("FootballMatchEventUpdate");
    this.$socket.unRegisterCallBack("FootballMatchStandingUpdate");
    this.$socket.unRegisterCallBack("FootballMatchLuckUpdate");
  },
};
</script>


// WEBPACK FOOTER //
// ./src/views/details/details.vue